import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { SessionService } from '../../data/service/session.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const sessionService = inject(SessionService);

  const isAuthenticated = sessionService.isAuthenticated();

  // If the request already has an x-api-key (e.g. validate-api-key), reuse it.
  const existingApiKey = req.headers.get('x-api-key');
  const storedApiKey = sessionService.getApiKey();

  // Only use stored API key when maintenance_auth says we are authenticated
  const apiKeyToUse = existingApiKey || (isAuthenticated ? storedApiKey : null);

  // If we are not authenticated (maintenance_auth missing/expired), force UI to show the popup
  if (!isAuthenticated) {
    sessionService.clearAuthentication();
    sessionService.checkAuthStatus();
  }

  const modifiedReq = apiKeyToUse
    ? req.clone({
        setHeaders: {
          'x-api-key': apiKeyToUse,
        },
      })
    : req;

  return next(modifiedReq).pipe(
    catchError((error: any) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        // Clear authentication and trigger modal display
        sessionService.clearAuthentication();
        sessionService.checkAuthStatus();
      }
      return throwError(() => error);
    })
  );
};
